/**
 * Role hierarchy utilities for filtering assignable roles.
 *
 * Hierarchy levels (lower = more powerful):
 *   0 — Owner   (wildcard '*' permission)
 *   1 — Admin   (system role named 'Admin')
 *   2 — Custom  (organization-created roles)
 *   3 — Member  (system role named 'Member')
 */

interface RoleLike {
  _id: string;
  name: string;
  permissions?: Record<string, number>;
  isSystem?: boolean;
  type?: 'admin' | 'user';
}

export function getRoleLevel(role: RoleLike): number {
  if (role.permissions?.['*'] !== undefined) return 0;
  if (role.isSystem && role.name === 'Admin') return 1;
  if (role.isSystem && role.name === 'Member') return 3;
  return 2;
}

/**
 * Filter a list of roles to only those the current user may assign,
 * i.e. roles whose level is >= the acting user's role level.
 */
export function filterRolesByHierarchy(
  allRoles: RoleLike[],
  currentRole: RoleLike | null | undefined,
): RoleLike[] {
  if (!currentRole) return [];
  const myLevel = getRoleLevel(currentRole);
  return allRoles.filter(r => getRoleLevel(r) >= myLevel);
}
